import React from 'react';
import { observer } from 'mobx-react-lite';

import { useStores } from 'hooks/useStores';

const Engine = observer(({ engineType, enginePower, engineVolume }) => {
  const {
    dictionariesStore: { engine_types },
  } = useStores();

  const isEngine = engineType || enginePower || engineVolume;
  if (!isEngine) return null;

  return (
    <tr>
      <td className="pale">Двигатель</td>
      <td>
        <span className="bold">
          {[
            engineVolume && `${engineVolume} л`,
            enginePower && `${enginePower} л.с.`,
            engineType && `${engine_types[engineType]}`,
          ]
            .filter((el) => el)
            .join(', ')}
        </span>
      </td>
    </tr>
  );
});

export default Engine;
